import { api } from './request';

export type AlertMetric = 'clicks' | 'conversions' | 'cvr' | 'revenue' | 'profit' | 'epc';
export type AlertCondition = 'lt' | 'gt';

export interface AlertRule {
  id: string;
  name: string;
  metric: AlertMetric;
  condition: AlertCondition;
  threshold: number;
  windowHours: number;
  campaignId: string | null;
  notifyEmail: string | null;
  webhookUrl: string | null;
  enabled: number;
  createdAt: number;
  updatedAt: number;
}

export interface AlertNotification {
  id: string;
  alertRuleId: string;
  metric: AlertMetric;
  currentValue: number;
  threshold: number;
  condition: AlertCondition;
  campaignId: string | null;
  campaignName: string | null;
  isRead: number;
  createdAt: number;
}

export const alertsApi = {
  getRules: () => api.get<AlertRule[]>('/alerts/rules'),
  createRule: (data: Omit<AlertRule, 'id' | 'createdAt' | 'updatedAt'>) =>
    api.post<AlertRule>('/alerts/rules', data),
  updateRule: (id: string, data: Partial<Omit<AlertRule, 'id' | 'createdAt' | 'updatedAt'>>) =>
    api.put<AlertRule>(`/alerts/rules/${id}`, data),
  deleteRule: (id: string) => api.delete(`/alerts/rules/${id}`),
  getNotifications: (unreadOnly = false) =>
    api.get<AlertNotification[]>(`/alerts/notifications${unreadOnly ? '?unread=1' : ''}`),
  markRead: (ids?: string[]) => api.post('/alerts/notifications/read', { ids }),
  check: () => api.post<AlertNotification[]>('/alerts/check', {}),
};
